import BusinessInfoPage from './BusinessInfoPage'

export default BusinessInfoPage
